import {
	AspectRatioContainer,
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Image,
	styled,
	Text,
	TextAlignment,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { COLOR_TOKEN } from '../../../../../helpers/color-tokens';

const LayerContentWrapper = styled.div`
	width: 100%;
	max-width: 700px;
	margin: 0 auto;
	& * {
		text-wrap: balance;
	}
`;

const GreyContainer = styled(Container)`
	background-color: ${COLOR_TOKEN.background.disabled};
`;

export const MasterWinnerLayer: React.FC = () => {
	return (
		<Container
			padding={{
				right: ContainerPadding.dynamic0100,
				bottom: ContainerPadding.dynamic0100,
				left: ContainerPadding.dynamic0100,
			}}
			horizontalAlign={'center'}
			wrap={'always'}
		>
			<AspectRatioContainer data-testid="aspect-ratio-container" ratio="2:1">
				<Image
					src={
						'https://assets.volkswagen.com/is/image/volkswagenag/seleccionado_fase4?Zml0PWNyb3AlMkMxJndpZD0xNjAwJmhlaT0xMjAwJmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJmM3MWE='
					}
					alt="Imagen Master de la carretera"
					style={{ borderRadius: '16px', objectFit: 'cover' }}
				/>
			</AspectRatioContainer>
			<LayerContentWrapper>
				<Container
					wrap={'always'}
					gutter={ContainerGutter.dynamic0100}
					padding={{
						top: ContainerPadding.dynamic0130,
						bottom: ContainerPadding.dynamic0100,
					}}
				>
					<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center}>
						<Text bold>¡Llegaste a meta!</Text> Eres uno de los 3 ganadores de Máster de la carretera
					</Text>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						<Text bold>¡Enhorabuena!</Text>
						<br />
						Ya formas parte del grupo exclusivo de personas que vivirán el primer Máster de la Carretera de Volkswagen.
						Tres experiencias de conducción únicas, en tres terrenos distintos, que podrás disfrutar durante un año, con
						el acompañante que elijas.
					</Text>
				</Container>
			</LayerContentWrapper>
			<GreyContainer
				stretchContent
				padding={{
					top: ContainerPadding.dynamic0050,
					bottom: ContainerPadding.dynamic0050,
					left: ContainerPadding.dynamic0050,
					right: ContainerPadding.dynamic0050,
				}}
			>
				<LayerContentWrapper>
					<Container wrap={'always'} gutter={ContainerGutter.dynamic0100}>
						<Text bold appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
							Apunta estas fechas y guárdate estos fines de semana:
						</Text>
						<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
							→ <Text bold>Escuela GTI</Text>
							<br />
							Aprenderás a maniobrar con más precisión, seguridad y adrenalina
							<br />
							<Text bold>12 y 13 de junio de 2026</Text>
							<br />
							<Text bold>Circuito Jarama, Madrid</Text>
							<br />
							<Text bold>Terreno: asfalto</Text>
							<br />
						</Text>
						<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
							→ <Text bold>Track Experience</Text>
							<br />
							Probarás los modelos deportivos, distintas motorizaciones y tecnologías
							<br />
							<Text bold>16 y 17 de octubre de 2026</Text>
							<br />
							<Text bold>Circuito Aspar, Valencia</Text>
							<br />
							<Text bold>Terreno: asfalto</Text>
							<br />
						</Text>
						<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
							→ <Text bold>Escuela 4Motion</Text>
							<br />
							Dominarás tu vehículo en nieve y hielo en condiciones extremas
							<br />
							<Text bold>12 y 13 de febrero de 2027</Text>
							<br />
							<Text bold>Circuito Pas de la Casa, Andorra</Text>
							<br />
							<Text bold>Terreno: hielo y nieve</Text>
							<br />
						</Text>
					</Container>
				</LayerContentWrapper>
			</GreyContainer>
			<LayerContentWrapper>
				<Container
					wrap={'always'}
					gutter={ContainerGutter.dynamic0100}
					padding={{
						top: ContainerPadding.dynamic0100,
					}}
				>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						Durante el máster contarás con el <Text bold>apoyo de nuestro equipo del Driving Experience</Text>. Antes de
						cada una de las escuelas, nos pondremos en contacto contigo para organizarlo todo. Ten en cuenta que las
						fechas pueden ajustarse en función de la disponibilidad del circuito.
					</Text>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						Y si surgen dudas o necesitas más información, <Text bold>no dudes en contactarnos:</Text>
						<br />—{' '}
						<CTA tag="a" href="mailto:club@volkswagendrivingexperience.es" emphasis="tertiary">
							club@volkswagendrivingexperience.es
						</CTA>
						<br />—{' '}
						<CTA tag="a" href="tel:627403284" emphasis="tertiary">
							627 403 284
						</CTA>
					</Text>
					<Text bold appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						¿Listo? Arrancamos
					</Text>
				</Container>
			</LayerContentWrapper>
		</Container>
	);
};
